<section class="cz-notification-configuration-item-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
        <h3 class="title" *ngIf="addNewItem">{{'$administration_notifications_configure_add_new' | translate}}</h3>
        <h3 class="title" *ngIf="!addNewItem">{{'$administration_notifications_configure_view_edit' | translate}}&nbsp;{{notificationTemplate.title}}</h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
            <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <p *ngIf="addNewItem">{{'$administration_notifications_dialog_add_new_desc' | translate}}</p>
    <mat-form-field class="form-field form-full-width-field notification-title">
      <mat-label>{{'$administration_notifications_dialog_title' | translate}}</mat-label>
      <input matInput type="text" required [formControl]="titleControl" />
    </mat-form-field>
    <!-- Add has-error to h5 below if user tries to save without any notification text. -->
    <h5 class="no-margin notification-text-title" [ngClass]="{'has-error': hasError}">{{'$administration_notifications_dialog_text' |translate}}<sup>*</sup></h5>
    <div class="mce-controls">
      <editor [apiKey]="tinyApiKey"
              [formControl]="textControl"
              [init]="editorConfig">
      </editor>
    </div>
  </mat-dialog-content>
  <mat-actions>
    <div class="row">
      <div class="col-xs">
        <button mat-stroked-button color="accent" mat-dialog-close *ngIf="addNewItem">{{'$btn_cancel' | translate}}</button>
        <button mat-button color="error" *ngIf="!addNewItem" (click)="deleteItem()">{{'$common_delete_item' | translate}}</button>
      </div>
      <div class="col-xs end-xs">
        <button mat-stroked-button color="accent" class="btn-cancel-item-exists" mat-dialog-close *ngIf="!addNewItem">{{'$btn_cancel' | translate}}</button>
        <button mat-flat-button color="accent" (click)="saveItem()">{{'$btn_save' | translate}}</button>
      </div>
    </div>
  </mat-actions>
</section>